<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="
            processamentosExpirados = $event,
            getAll()
          "
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';
import pusherMixins from '@/mixins/pusherMixins';
import tourMixins from '@/mixins/tourMixins';

export default {

  components: {
    Tabela: () => import('@/components/simulacoesLaudosIncrementais/Tabela.vue')
  },
  mixins: [pusherMixins, tourMixins],

  data: () => ({
    items: [],
    loading: false,
    processamentosExpirados: false,
    arrTour: [
      {
        element: '#btn-nova-simulacao',
        intro: 'Clicando neste botão você poderá criar novas Simulações de Laudos Express.',
        scrollTo: 'tooltip',
        position: 'right'
      },
      {
        element: '#simulacao-historico-search',
        intro: 'Neste campo você poderá pesquisar por Simulações de Laudos Express já existentes.',
        scrollTo: 'tooltip',
        position: 'bottom'
      },
      {
        element: '#action-download-simulacao',
        intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua Simulação de Laudo Express.',
        scrollTo: 'tooltip',
        position: 'left'
      },
      {
        element: '#action-edit-simulacao',
        intro: 'Clicando neste ícone você poderá editar sua Simulação de Laudo Express.',
        scrollTo: 'tooltip',
        position: 'left'
      },   
      {
        element: '#action-more-simulacao',
        intro: 'Aqui você acessa outras opções para sua Simulação de Laudo Express, como ver mais detalhes, executá-la novamente ou deletá-la.',
        scrollTo: 'tooltip',
        position: 'left'
      }
    ],
    loading: false
  }),

  mounted() {
    this.subscribe();
    this.getAll();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('reload-pag-simulacao-laudos-incrementais', () => {
        this.getAll();
      });
    },

    getAll() {
      this.loading = true;

      SimulacoesLaudosIncrementaisService.getAll(this.processamentosExpirados)
        .then(response => this.items = response.data.data)
        .catch (error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar simulações de laudos express.', '', {position:'topRight'});
        }) 
        .finally(() => { this.loading = false, this.iniciarTourPagina();});
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
  
      let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 2);
      this.iniciarTour(arrTourFormatted);
    }
  }
};
</script>